<template>
  <div class="max-w-screen-xl mx-auto flex justify-center flex-col px-4 lg:flex-row md:pt-12 pt-0 md:pb-8  ">
    <section
      ref="content"
      tabindex="-1"
      class="w-full content-container theme-page-content pb-0"
      :class="{'sidebar-enabled' : enableSidebar}"
      aria-label="Page content"
    >
      <slot />
    </section>
    <!-- TODO implement a longer term solution to just display sidebar within certain contexts -->
    <div
      v-if="visibleSearchbar && enableSidebar"
      class="lg:w-1/3 w-full hidden md:block lg:ml-12"
    >
      <SidebarContent />
    </div>
  </div>
</template>

<script>
import SidebarContent from './SidebarContent'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { SIDEBAR } from '@/constants/featureFlags'

export default {
  setup() {
    const { enableSidebar } = useFeatureFlags({
      enableSidebar: SIDEBAR,
    })

    return { enableSidebar } // now we can use enableSidebar for v-if to enable or disable the sidebar in template
  },
  components: { SidebarContent },
  props: {
    page: {
      type: String,
      default: '',
    },
  },
  computed: {
    visibleSearchbar() {
      return ['custom-page', 'departments/_id', 'search'].includes(this.page)
    },
  },
}
</script>

<style scoped>
.rec-block {
  @apply text-gray-900 px-4 py-2;
}

@screen lg {
  /* to override theme-page-content */
  .content-container.sidebar-enabled {
    @apply w-2/3;
  }
}
</style>
